export default "//yastatic.net/s3/distribution/pythia/frontend/_/3e16cb8f1853c1e786c10f5e9ba8506c.png";